// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify-extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../k8-opt-exec-ST-a828a81199fe/bin/redo/shopify-extension/webpack.bin.runfiles/npm_css-loader_6.7.3-dc3fc578/files/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "._5-0 {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n._5-1 {\n  align-items: center;\n  display: flex;\n  width: 100%;\n  margin: 15px 0;\n  border-radius: 0px;\n}\n\n._5-2 {\n  background-color: #11375b;\n}\n\n._5-3 {\n  text-wrap: wrap;\n}\n\n._5-4 {\n  text-decoration: underline;\n  font-weight: 400;\n  color: black;\n}\n\n._5-4._5-5 {\n    cursor: not-allowed;\n  }\n\n._5-4._5-6 {\n    cursor: wait;\n  }\n\n._5-7 {\n  gap: 0px;\n}\n\n._5-8 {\n  position: absolute;\n}\n", ""]);
// Exports
export var fullContainer = "_5-0";
export var coverageButtonContainer = "_5-1";
export var blue = "_5-2";
export var textWrap = "_5-3";
export var linkButton = "_5-4";
export var disabled = "_5-5";
export var pending = "_5-6";
export var noGap = "_5-7";
export var loader = "_5-8";
export default ___CSS_LOADER_EXPORT___;
